import * as React from "react";
import Button from "../components/Button";
import Typography from "../components/Typography";
import ProductHeroLayout from "./ProductHeroLayout";

export default function ProductHero() {
  return (
    <ProductHeroLayout
      sxBackground={{
        backgroundImage: `url(/images/homepage_hero.jpeg)`,
        backgroundColor: "#7fc7d9", // Average color of the background image.
        backgroundPosition: "center",
      }}
    >
      {/* Increase the network loading priority of the background image. */}
      <img
        style={{ display: "none" }}
        src="/images/homepage_hero.jpeg"
        alt="increase priority"
      />
      <Typography
        color="inherit"
        align="center"
        variant="h2"
        marked="center"
        sx={{ fontSize: "40px" }}
      >
        intelligence that isn't artificial
      </Typography>
      <Typography
        color="inherit"
        align="center"
        variant="h5"
        sx={{ mb: 4, mt: { xs: 4, sm: 10 } }}
      >
        From web design to application development, we offer the skills you need
        to take your business to the next level
      </Typography>
      <Button
        color="secondary"
        variant="contained"
        size="large"
        component="a"
        href="https://calendly.com/d/y5x-m6t-vwg/30min"
        target="_blank"
        sx={{ minWidth: 200 }}
      >
        Contact
      </Button>
      <Typography variant="body2" color="inherit" sx={{ mt: 2 }}>
        See how we can help
      </Typography>
    </ProductHeroLayout>
  );
}
